export default function extractQrElements (scanResult: string): string[] {
    const scanResultRegex = /^(\d+)-(?:batch-(\d+))?/i;
    const match = scanResult.match(scanResultRegex);

    return match && match[1] ? match.slice(1) : [];
}
